import styled from 'styled-components';

export const StyledMenu = styled.nav<{ open: boolean }>`
    display: flex;
    flex-direction: column;
    //justify-content: center;
    background: #fff;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-100%)")};
    height: 100vh;
    text-align: left;
    padding: "3rem";
    position: fixed;
    top: 7rem;
  padding-left: 2rem;
    left: 0;
    transition: transform 0.3s ease-in-out;
    z-index: 9999;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 6rem;
    @media (max-width: 576px) {
        width: 20%;
    }

    //a {
    //    font-size: 2rem;
    //    text-transform: uppercase;
    //    padding: 2rem 0;
    //    font-weight: bold;
    //    letter-spacing: 0.5rem;
    //    color: #0d0c1d;
    //    text-decoration: none;
    //    transition: color 0.3s linear;
    //
    //    @media (max-width: 576px) {
    //        font-size: 1.5rem;
    //        text-align: center;
    //    }
    //
    //    &:hover {
    //        color: #343078;
    //    }
    //}

`;

export const StyledBurger = styled.button<{ open: boolean; right?: string }>`
    //position: absolute;
    //top: 2rem;
    // right: ${({ right }) => right || "2rem"};
    transition: ease all 0.5s;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 2rem;
    height: 2rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 10;

    &:focus {
        outline: none;
    }

    div {
        width: 2rem;
        height: 1px;
        background: #3a966c;
        border-radius: 10px;
        transition: all 0.3s linear;
        position: relative;
        transform-origin: 1px;

        :first-child {
            transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
        }

        :nth-child(2) {
            opacity: ${({ open }) => (open ? "0" : "1")};
            transform: ${({ open }) =>
        open ? "translateX(20px)" : "translateX(0)"};
        }

        :nth-child(3) {
            transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
        }
    }
`;
